import moment from 'moment-timezone';
import { useMemo } from 'react';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import useSelectFetchAccountAppointments from '../../../hooks/useSelectFetchAccountAppointments';
import { reorderUpcomingAppointments } from '../../../util';

export default (userProfileId: any, allowPastAppointments?: boolean) => {
  const { upcomingAppointments, pastAppointments } =
    useSelectFetchAccountAppointments(userProfileId);

  return useMemo(() => {
    const isEmptyUpcoming = isEmpty(upcomingAppointments);
    const isEmptyPast = isEmpty(pastAppointments);

    if (isEmptyUpcoming) {
      if (isEmptyPast) return { appointment: null, isLastAppointment: false };

      const lastAppointment: any = last(pastAppointments);
      if (moment().isBefore(moment(lastAppointment.discharged_timestamp).add(24, 'hours'))) {
        // There's a 24 hour buffer where we still consider a past appointment "upcoming"
        return { appointment: lastAppointment, isLastAppointment: false };
      }
      if (allowPastAppointments) {
        return { appointment: lastAppointment, isLastAppointment: true };
      }
    }

    return {
      appointment: reorderUpcomingAppointments(upcomingAppointments)[0],
      isLastAppointment: false,
    };
  }, [upcomingAppointments, pastAppointments, allowPastAppointments]);
};
